import { createAsyncThunk } from '@reduxjs/toolkit';

import { categoryApi } from 'src/api/category';
import { toast } from 'react-toastify';

export const createCategory = createAsyncThunk(
  'category/create-category',
  async (data, thunkApi) => {
    try {
      const { payload } = data;

      const response = await categoryApi.createCategory(payload);

      toast(response.data.message, { type: 'success' });

      thunkApi.dispatch(fetchCategories({}));

      return response.data;
    } catch (error) {
      console.error('createCategory[error]', error);

      return toast(error.response.data.message, { type: 'error' });
    }
  }
);

export const fetchCategories = createAsyncThunk('category/fetch-categories', async (data) => {
  try {
    const response = await categoryApi.fetchCategories(data);

    return response.data;
  } catch (error) {
    console.error('fetchCategories[error]', error);

    return toast(error.response.data.message, { type: 'error' });
  }
});

export const updateCategory = createAsyncThunk(
  'category/update-category',
  async (data, thunkApi) => {
    try {
      const { id, payload } = data;

      const response = await categoryApi.updateCategory(id, payload);

      toast(response.data.message, { type: 'success' });

      thunkApi.dispatch(fetchCategories({}));

      return response.data;
    } catch (error) {
      console.error('updateCategory[error]', error);

      return toast(error.response.data.message, { type: 'error' });
    }
  }
);

export const deleteCategory = createAsyncThunk(
  'category/delete-category',
  async (data, thunkApi) => {
    try {
      const { id } = data;

      const response = await categoryApi.deleteCategory(id);

      toast(response.data.message, { type: 'success' });

      thunkApi.dispatch(fetchCategories({}));

      return response.data;
    } catch (error) {
      console.error('deleteCategory[error]', error);

      return toast(error.response.data.message, { type: 'error' });
    }
  }
);
